import { createContext } from "react";

const CurrentPageComponentContext = createContext();

export default CurrentPageComponentContext;
